import posthog from 'posthog-js'

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'

export function initPostHog() {
  if (!POSTHOG_KEY) return

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    person_profiles: 'identified_only',
    disable_session_recording: false,
    respect_dnt: false,
    capture_performance: {
      web_vitals: true,
      web_vitals_allowed_metrics: ['CLS', 'LCP', 'INP', 'FCP'],
    },
  })
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return
  posthog.identify(userId, properties)
}

export function resetUser() {
  if (!POSTHOG_KEY) return
  posthog.reset()
}

export function captureEvent(eventName: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return
  posthog.capture(eventName, properties)
}
